// Client helpers for the llm-proxy billing endpoints. Mirrors orgs.js postMembership.
import { authHeaders } from '../ai/authedFetch';

const PROXY_BASE = (process.env.REACT_APP_GPT_API || 'http://localhost:8020/api/chat').replace(/\/api\/chat$/, '');

async function postBilling(path, body) {
  const headers = { 'Content-Type': 'application/json', ...(await authHeaders()) };
  const resp = await fetch(`${PROXY_BASE}${path}`, { method: 'POST', headers, body: JSON.stringify(body || {}) });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.error || `billing request failed (${resp.status})`);
  return data;
}

// The self-serve checkout client was removed with the $500 plan (2026-10-29). The
// portal stays so existing subscribers can manage or cancel.
export async function createPortalSession(orgId) {
  return postBilling('/billing/portal-session', { orgId });
}
